import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const Menu = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: auto;
  width: 35px;

  &.expanded {
    width: 200px;

    /* div[class*='Item'] {
      text-align: left;
      padding: 5px 0 5px 10px;
      flex-direction: row;
    }

    div[class*='Label'] {
      display: inline-block;
      margin-left: 10px;
      position: relative;
    } */
  }
`;

const Item = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  line-height: 1.33;
  cursor: pointer;
  margin-bottom: 5px;
  padding: 9px 5px;
  text-align: center;
  user-select: none;
  transition: var(--ph-background-transition);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: var(--white);

  &:hover {
    outline: 3px solid var(--white);
  }
`;

const Icon = styled(Svg)`
  height: 15px;
  width: 15px;
  fill: #999;
  top: 50%;
  transform: translateY(-50%);
`;

const Label = styled('div')`
  font-size: var(--ph-text-xs);
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #999;
`;

const SelectWrapper = styled('div')`
  position: absolute;
  right: 4rem;
  top: 4rem;
  border-radius: var(--ph-border-radius-sm);
  background-color: #2a333d;
  z-index: 9999;
  overflow: hidden;
  min-width: 150px;
`;

const Language = styled('div')`
  padding: 10px 15px;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--white);
  cursor: pointer;
  user-select: none;
  transition: var(--ph-background-transition);

  &:hover,
  &.selected {
    background-color: var(--black-900);
  }

  &:first-child {
    padding-top: 15px;
  }

  &:last-child {
    padding-bottom: 15px;
  }
`;

export default { Menu, Item, Icon, Label, SelectWrapper, Language };
